import React from 'react'
import { getAppConfig } from '@/config/config'
import styles from './SectionTitleLink.module.scss'
import Icon from '@/components/Icon/Icon'
import { clsx } from 'clsx'

type SectionTitleLinkProps = {
  href: string
  target?: string
  rel?: string
  className?: string
  children: React.ReactNode
}

export default function SectionTitleLink(props: SectionTitleLinkProps) {
  const cleanedProps = { ...props }
  const config = getAppConfig()
  if (
    cleanedProps.href &&
    cleanedProps.href.includes(`www.n-tv.de${config.basePath}`) &&
    new URL(cleanedProps.href).host.includes('n-tv.de')
  ) {
    cleanedProps.href = new URL(cleanedProps.href).pathname
  }

  return (
    <a {...cleanedProps} className={clsx(styles['section-title-icon-link'], props.className)}>
      {cleanedProps.children}
      <Icon name="chevronRight" size={48} className={styles['arrow-icon']} />
    </a>
  )
}
